import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";

const NewsPage = () => {
  const [news, setNews] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    fetch("https://kasiaweb.ilakshyaerp.in/api/news")
      .then((res) => res.json())
      .then((data) => setNews(Array.isArray(data) ? data : []))
      .catch((err) => console.log("News fetch error:", err));
  }, []);

  return (
    <>
      <Header toggleSidebar={() => setOpen(true)} />
      <Sidebar isOpen={open} close={() => setOpen(false)} />

      <div className="about-hero">
        <div className="about-overlay">
          <h1>NEWS</h1>
          <p>A glimpse into school traditions and values</p>
          <Breadcrumb />
        </div>
      </div>

      <div className="gallery-section">
        <h2 className="gallery-title">SCHOOL NEWS</h2>
      </div>

      <div className="container">

        <div className="news-grid">
          {news.length > 0 ? (
            news.map((n) => (
              <div className="news-card-modern" key={n.id}>

                <img
                  src={`https://kasiaweb.ilakshyaerp.in/uploads/news/${n.image}`}
                  alt="news"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setSelectedImage(
                      `https://kasiaweb.ilakshyaerp.in/uploads/news/${n.image}`
                    )
                  }
                />

                <div className="news-content">
                  <h3>{n.title}</h3>
                  <p>{n.description}</p>
                </div>

              </div>
            ))
          ) : (
            <p className="life-empty">
              No news available
            </p>
          )}
        </div>
      </div>

      {selectedImage && (
        <div
          className="event-modal"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="event-close"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImage(null);
            }}
          >
            ✕
          </button>

          <img
            src={selectedImage}
            alt=""
            className="event-full-image"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      <Footer />
    </>
  );
};

export default NewsPage;